import uiActions from "../../redux/ui/action";
import { EXPLORE_COURSES_PATH } from "../../custom_utilities/dashboardBannerNavigation";

export const DASHBOARD_HOME_PATH = "/dashboard";

export function navigateToExploreMotion(history, dispatch) {
  dispatch(uiActions.startLoading());
  history.push(EXPLORE_COURSES_PATH);
}

export function navigateToDashboardHome(history, dispatch) {
  dispatch(uiActions.startLoading());
  history.push(DASHBOARD_HOME_PATH);
}
